<template>
  <div>
    <div class="md-layout login">
      <div class="md-layout-item">
        <img alt="Vue logo" src="../assets/logo.svg" />
        <form autocomplete="off" style="" class>
          <label>e-mail</label>
          <md-field>
            <md-icon>email</md-icon>
            <label>Enter your e-mail</label>
            <md-input @keyup.native.enter="login"  v-model="email" ref="email"></md-input>
          </md-field>
          <label>Password</label>
          <md-field>
            <md-icon>lock</md-icon>
            <label>Enter your Password</label>
            <md-input @keyup.native.enter="login" v-model="password" type="password" ref="password"></md-input>
          </md-field>
        </form>
        <div v-if="loginError" class="md-error">Invalid username or password.</div>
        <md-button @click="login" class="md-raised md-accent login-btn">Login</md-button>
        <div class="md-layout">
          <div
            class="md-layout-item p10 copyright"
          >© UT Health San Antonio School of Dentistry All Right Reserved</div>
        </div>
      </div>
      <div class="md-layout login p40" style="display:none;">
        <div class="md-layout-item text-left">
          <md-checkbox v-model="rememberMe">Remember me</md-checkbox>
        </div>
        <div class="md-layout-item forgot-password ">
          <a href="#">Forgot password?</a>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import LoginUser from "../graphql/LoginUser.gql";
export default {
  name: "Login",
  data() {
    return {
      email: "",
      password: "",
      rememberMe: false,
      loginError: false
    };
  },
  methods: {
    login() {
      let self = this;
      this.$apollo.mutate({
        mutation: LoginUser,
        variables: {
          email: this.email,
          password: this.password
        },
        update(
          store,
          {
            data: { loginUser }
          }
        ) {
          window.localStorage.setItem("apollo-token", loginUser);
          self.$emit("update-user");
          self.$router.push("/");
        }
      }).catch(()=>{
        this.loginError = true;
        setTimeout(() => {
          this.loginError = false;
        }, 3000);
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.md-error {
  background-color: #E41E26;
  color: white;
  font-weight: bold;
  margin: 10px 12px;
  border-radius: 20px;
  padding: 4px;
}
.forgot-password {
  text-align: right;
  a {

    color: #fff !important;
    padding: 13px 0;
    display: inline-block;
  }
}
.copyright {
  color: #fff;
  font-size: 12px;
  position: fixed;
  text-align: center;
  bottom: 0;
  left: 0;
  width: 100%;
}
.p10 {
  padding: 10px;
}
.p40 {
  padding: 40px 16px;
}
.login {
  margin: 0 auto;
  max-width: 320px;
  .md-button {
    .md-ripple {
      border-radius: 0px;
      padding-left: 20px;
      padding-right: 20px;
    }
    min-width: 160px;
  }

}
form {
  padding-top: 30px;
  text-align: left;
  label {
    margin-left: 30px;
    font-weight: 700;
    color: #fff;
  }
}
</style>